module.exports = {"AB":"Alberta","BC":"British Columbia","MB":"Manitoba","NB":"New Brunswick","NL":"Newfoundland and Labrador","NS":"Nova Scotia","NT":"Northwest Territories","NU":"Nunavut","ON":"Ontario","PE":"Prince Edward Island","QC":"Québec","SK":"Saskatchewan","YT":"Yukon"}


//////////////////
// WEBPACK FOOTER
// ./src/config/candianProvinces.json
// module id = 476
// module chunks = 1